import WMSCapabilities from 'ol/format/WMSCapabilities';
import { config } from '../../config/Config';
import { Layer } from '../../models/Layers';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { TileWMS } from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import { createXYZ } from 'ol/tilegrid';
import { transformExtent } from 'ol/proj';
import { toast } from 'react-toastify';

export let isLoadingExternal = false;

export async function loadExternalCapabilities(url, handleExternalUserLayerAdd, externalLayersArray) {
  await loadExternalCapabilitiesWMS(url, handleExternalUserLayerAdd, externalLayersArray);
}

/**
 *
 * @param {*} url
 * @param {*} map
 * @param {*} arrayLayers
 * @desc funcion para cargar wms externos
 */
async function loadExternalCapabilitiesWMS(url, handleExternalUserLayerAdd, externalLayersArray) {
  isLoadingExternal = true;
  let re = new RegExp('(http|https)://');
  let substr = re.test(url);
  if (!substr) {
    url = 'https://' + url;
  }

  let re2 = new RegExp('\\?');
  let substr2 = re2.test(url);
  if (!substr2) {
    url = url + '?service=wms&version=1.1.1&request=GetCapabilities';
  } else {
    url = url + '&service=wms&version=1.1.1&request=GetCapabilities';
  }

  let formatWMS = new WMSCapabilities();

  fetch(
    config.url_proxy_openlayers +
      new URLSearchParams({
        url: url,
        mode: 'native'
      }),
    {
      method: 'GET',
      async: false
    }
  )
    .then((request) => {
      return request.text();
    })
    .then((text) => {
      let xmlText = new window.DOMParser().parseFromString(text, 'text/xml');
      let capabilities;
      if (!xmlText || !xmlText.documentElement) {
        xmlText = text;
      }
      try {
        capabilities = formatWMS.read(xmlText);
      } catch (error) {
        toast.error(getTranslatedKey('error_carregarCapes'), { autoClose: 4000, pauseOnHover: true });
        isLoadingExternal = false;
        return;
      }
      if (capabilities.error !== undefined) {
        toast.error(getTranslatedKey('error_carregarCapes'), { autoClose: 4000, pauseOnHover: true });
        isLoadingExternal = false;
        return;
      }

      let layers = capabilities.Capability.Layer.Layer;

      let layersAux = flattenLayers(layers);

      if (layersAux.length > 0) {
        let url2 = capabilities.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource;
        let layersObject = parseCapabilities(layersAux, url2);
        let childLayers = [];
        for (let urlObject in layersObject) {
          if (layersObject.hasOwnProperty(urlObject)) {
            let layer = new Layer();
            layer.setTitle(urlObject);
            for (let layer in layersObject[urlObject]) {
              let urlName = layersObject[urlObject];
              childLayers.push(urlName[layer]);
            }
            layer.setChildLayers(childLayers);
            let index = externalLayersArray.find((l) => l.getTitle() === layer.getTitle());
            if (index === undefined) externalLayersArray.unshift(layer);
          }
        }
        handleExternalUserLayerAdd();
      }
      isLoadingExternal = false;
    })

    .catch((error) => {
      toast.error(getTranslatedKey('error_carregarCapes'), { autoClose: 4000, pauseOnHover: true });
      isLoadingExternal = false;
    });
}

const flattenLayers = (layers) => {
  let layersAux = [];
  for (let i = 0; i < layers.length; ++i) {
    if (layers[i].hasOwnProperty('Layer')) {
      layersAux = layersAux.concat(flattenLayers(layers[i].Layer));
    } else {
      layersAux.push(layers[i]);
    }
  }
  return layersAux;
};

/**
 *
 * @param {*} layers
 * @param {*} url
 * @param {*} map
 * @param {*} arrayLayers
 * @desc funcion para parsear la layer wms y cargarla en el mapa
 */
function parseCapabilities(layers, url) {
  let groupParams = {};

  let objResult = {};
  objResult[url] = groupParams;
  if (layers.length > 0) {
    let groupName = url;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i] !== undefined) {
        let obj = layers[i];

        var tileGrid = createXYZ({
          extent: transformExtent([258000, 4485000, 536000, 4752000], config.EPSG, config.EPSG_mapa),
          tileSize: 512
        });

        let sourceWMS = new TileWMS({
          url: url,
          crossOrigin: 'Anonymous',
          params: {
            LAYERS: obj.Name,
            TRANSPARENT: true,
            SERVICE: 'WMS',
            VERSION: config.capabilities_version,
            SRS: config.EPSG_mapa,
            WIDTH: 512,
            HEIGHT: 512,
            TILED: true
          },
          serverType: 'geoserver',
          tileGrid: tileGrid
        });

        let layer = new TileLayer({
          source: sourceWMS
        });

        layer.setVisible(true);
        layer.groupParams = {};
        layer.groupParams.name = groupName;
        layer.groupParams.title = groupName;
        layer.Abstract = obj.Abstract;

        if (obj.queryable) {
          layer.queryable = '1';
        } else {
          layer.queryable = '0';
        }
        let sitepLayer = new Layer(obj, true, false, true);
        sitepLayer.setOLLayer(layer);
        sitepLayer.setOnlineResource(url);

        sourceWMS.on(['imageloaderror'], function () {
          sitepLayer.setError(true);
        });

        groupParams[sitepLayer.getTitle()] = sitepLayer;
      }
    }
  }
  return objResult;
}
